import { useEffect } from 'react'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let signed_date = useDataValue({
    context: 'contract',
    path: 'signed_date',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'payor',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!signed_date) return

    // refetch payor's details to reflect that the contract has been signed
    submit({ type: 'reFetch' })
  }, [signed_date]) // eslint-disable-line react-hooks/exhaustive-deps
  // ignore submit

  return <View {...props} />
}
